module.exports = __webpack_public_path__ + "img/shop.d2801a84.png";